import React, { useContext, useEffect, useState } from "react";
import "../styles/sortableData.scss";
import GaleriaDTO from "../dto/GaleriaDTO";
import { useSortableData } from "../utils/UseSorteableDataHook";
import { useNavigate } from "react-router-dom";
import { axiosInstanceMain } from "../utils/axiosGlobalUtils";
import * as FaIcons from "react-icons/fa";
import { Button } from "../components/Common/button/button.component";
import { MaximizeIcon } from "../icons/maximize-icon/maximize-icon.component";
import Select from "react-select";
import { useLocales, IFiltros } from "../hooks/locales.hook";
import Navbar from "../components/Navbar";
import { CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import Footer from "./Home/components/Footer";
import { TenantsContext } from "../context/tenants.context";
import { styled } from "@mui/material/styles";
import { getGalerias } from "./Galerias/services/galerias.services";
import { LocalAdminDTO } from "../dto/LocalDTO";

const ContentInputSearch = styled("div")({
  display: "flex",
});

const FirstRow = styled("div")({
  display: "flex",
  width: "100%",
  flexWrap: "wrap",
  margin: "10px",
  gap: "10px",
});

const QueryTexto = styled("div")({
  alignItems: "flex-end",
  display: "flex",
  flexDirection: "column",
  width: "25%",
  "@media (max-width: 425px)": {
    width: "100%",
  },
});

const ContentSelect = styled("div")({
  width: "30%",
  fontSize: "1rem",
  lineHeight: "1.6",
  borderRadius: "0.3rem",
  "@media (max-width: 425px)": {
    width: "100%",
  },
});

const ContentButton = styled("div")({});

const ContentSoloActivos = styled("div")({
  width: "10%",
  marginTop: "10px",
  "@media (max-width: 425px)": {
    width: "80%",
  },
});

const ButtonCustom = styled(Button)({
  width: "80%",
});

const InputCustom = styled("input")({
  width: "100%",
  padding: "0.5rem 0.5rem",
  fontSize: "1rem",
  border: '1px solid #999', 
});

const InputIdCustom = styled("input")({
  height: "50%",
  width: "17%",
  fontSize: "1rem",
  padding: "0.5rem 0.5rem",
  border: '1px solid #999', 
  "@media (max-width: 425px)": {
    width: "100%",
  },
});

const ButtonWhatsapp = styled(Button)({
  width: "95%",
  fontSize: "0.75rem",
});

const CheckBox = styled("div")({
  display: "flex",
  gap: "10px",
  alignItems: "center",
  color: "grey",
});

// Mobile
const Container = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "stretch",
  width: "97%",
  border: "1px solid",
  margin: "5px",
  padding: "5px",
  borderRadius: "5px",
});

const OneColumn = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "stretch",
  width: "100%",
  gap: "4px",
});

const Title = styled("p")({
  fontWeight: "bold",
  marginBottom: "0.25rem",
  fontSize: "4vw",
  color: `${(props: any) => (props.color ? "#" + props.color : "#212529")}`,
});

const TwoColumn = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "stretch",
  justifyContent: "space-between",
  width: "100%",
  gap: "2px",
  marginBottom: "5px",
});

const ButtonCustomMobile = styled(Button)({
  width: "40%",
});

const ButtonWhatsappMobile = styled(Button)({
  width: "40%",
  fontSize: "0.75rem",
});

const AbmLocalesPage: React.FC = () => {
  const { locales, updateLocales, filtros, updateFiltros } = useLocales();
  const [galerias, setGalerias] = useState<GaleriaDTO[]>();
  const [queryIdLocal, setQueryIdLocal] = useState<string>("");
  const [queryFiltrosLocal, setQueryFiltrosLocal] = useState<string>("");
  const [queryPalabraCompleta, setQueryPalabraCompleta] =
    useState<boolean>(false);
  const [queryIdsGaleria, setQueryIdsGaleria] = useState<string[]>();
  const [galeriasSeleccionadas, setGaleriasSeleccionadas] =
    useState<GaleriaDTO[]>();
  const { items, requestSort, sortConfig } = useSortableData(
    locales ? locales : []
  );
  const { tenant } = useContext(TenantsContext);

  let navigate = useNavigate();
  const [soloActivos, setSoloActivos] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const customStyles = {
    control: (provided: Record<string, unknown>) => ({
      ...provided,
      borderWidth: "1px",
      borderColor: "#999",
      borderStyle: "inset",
      "&:hover": {},
      "&:focus": {
        borderWidth: "1px",
        borderColor: "#999",
        borderStyle: "inset",
      },
    }),
  };

  const getClassNamesFor = (name: string) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig["key"] === name ? sortConfig["direction"] : undefined;
  };

  const searchPremises = () => {
    let filtros: string = `/admin/${tenant.path}/locales?nuevo&`;
    if (queryIdLocal) filtros = filtros + `idLocal=${queryIdLocal.trim()}&`;
    if (queryIdsGaleria) filtros = filtros + `idGaleria=${queryIdsGaleria}&`;
    if (queryFiltrosLocal)
      filtros =
        filtros +
        `q=${encodeURIComponent(
          queryFiltrosLocal
        )}&solo-palabra-completa=${queryPalabraCompleta}`;
    if (soloActivos) filtros = filtros + "&solo-activos=true";
    setLoading(true);
    axiosInstanceMain
      .get(filtros)
      .then((result) => {
        updateLocales(result.data.data);
        const filtros: IFiltros = {
          idLocal: queryIdLocal ? queryIdLocal : undefined,
          queryTexto: queryFiltrosLocal ? queryFiltrosLocal : undefined,
          palabraCompleta: queryPalabraCompleta
            ? queryPalabraCompleta
            : undefined,
          idsGalerias: queryIdsGaleria ? queryIdsGaleria : undefined,
          soloActivos: soloActivos ? soloActivos : undefined,
        };
        updateFiltros(filtros);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const getListadoGalerias = () => {
    setLoading(true);
    getGalerias(tenant)
      .then((result) => {
        const galeriasResult: GaleriaDTO[] = [];
        if (result.data.data) {
          result.data.data.map((g: GaleriaDTO) => {
            const galeriaResult: GaleriaDTO = {
              value: g.idGaleria,
              label: g.nombre,
            };
            galeriasResult.push(galeriaResult);
          });
        }
        setGalerias(galeriasResult);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const handleClickInLine = (idLocal: number) => {
    if (isMobile) redirectToLocalDetail(idLocal);
  };

  const redirectToLocalDetail = (idLocal: number) => {
    navigate("admin-local/" + idLocal);
  };

  useEffect(() => {
    getListadoGalerias();
  }, []);

  useEffect(() => {
    if (filtros && galerias) {
      if (filtros.idLocal) setQueryIdLocal(filtros.idLocal);
      if (filtros.queryTexto) setQueryFiltrosLocal(filtros.queryTexto);
      if (filtros.palabraCompleta)
        setQueryPalabraCompleta(filtros.palabraCompleta);
      if (filtros.idsGalerias) {
        setQueryIdsGaleria(filtros.idsGalerias);
        const newGaleriasFormatter: GaleriaDTO[] = [];
        filtros.idsGalerias.map((i) => {
          const gal = galerias.find((g) => {
            return g.value === i;
          });

          if (gal) newGaleriasFormatter.push(gal);
        });

        setGaleriasSeleccionadas(newGaleriasFormatter);
      }
      if (filtros.soloActivos) setSoloActivos(filtros.soloActivos);
    }
  }, [filtros, galerias]);

  // console.log(galerias?.find(g => queryIdsGaleria?.includes(g.value.toString())));

  useEffect(() => {
    if (queryIdsGaleria)
      setGaleriasSeleccionadas(
        galerias?.filter((g: GaleriaDTO) =>
          queryIdsGaleria.map((q) => q.toString())?.includes(g.value.toString())
        )
      );
  }, [queryIdsGaleria]);

  // console.log(galerias?.find(g));
  return (
    <>
      <div className="principal">
        <Navbar title="ABM de Locales" searchBar={{ searchBar: true }} />
        <ContentInputSearch>
          <form
            style={{ width: "100%" }}
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div className="input-group">
              <FirstRow>
                <InputIdCustom
                  type="number"
                  onChange={(e) =>
                    setQueryIdLocal(e.target.value.toLowerCase())
                  }
                  placeholder="Busca por Id del local"
                  className="form-outline form-control-lg"
                  value={queryIdLocal}
                />
                <QueryTexto>
                  <InputCustom
                    type="search"
                    onChange={(e) =>
                      // !e.target.value.startsWith("&") &&
                      setQueryFiltrosLocal(e.target.value.toLowerCase())
                    }
                    placeholder="Busca por nombre, dirección, wsp y usuario"
                    className="form-outline form-control-lg"
                    value={queryFiltrosLocal}
                  />
                  <CheckBox>
                    Buscar por palabra completa
                    <input
                      type="checkbox"
                      value="Buscar por palabra completa"
                      onChange={(e) =>
                        setQueryPalabraCompleta(e.target.checked)
                      }
                      checked={queryPalabraCompleta}
                    />
                  </CheckBox>
                </QueryTexto>
                <ContentSelect>
                  <Select
                    styles={customStyles}
                    options={galerias as GaleriaDTO[]}
                    value={galeriasSeleccionadas}
                    isMulti
                    placeholder="Busca por galerias"
                    onChange={(e) => {
                      let galeriasSelected: string[] = [];
                      e.map((f): void => {
                        if (f) galeriasSelected.push(f.value);
                      });
                      setQueryIdsGaleria(galeriasSelected);
                      setGaleriasSeleccionadas(e as GaleriaDTO[]);
                    }}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </ContentSelect>
                <ContentSoloActivos>
                  <CheckBox>
                    <input
                      type="checkbox"
                      value="Solo activos"
                      onChange={(e) => setSoloActivos(e.target.checked)}
                      checked={soloActivos}
                    />
                    Solo activos
                  </CheckBox>
                </ContentSoloActivos>
                <ContentButton>
                  <button
                    type="submit"
                    onClick={searchPremises}
                    className="btn btn-primary btn-lg"
                  >
                    <FaIcons.FaSearch />
                  </button>
                </ContentButton>
              </FirstRow>
            </div>
          </form>
        </ContentInputSearch>

        {loading && <CircularProgress />}

        {isMobile ? (
          <>
            {items?.map((item: LocalAdminDTO, index) => {
              const whpp: any = item.medioDeContactoList?.find(
                (x: any) => x.tipo === 1
              );

              return (
                <div key={index}>
                  <Container
                    key={index}
                    className={
                      item.status === "Aprobado"
                        ? "approved"
                        : item.status === "Rechazado"
                        ? "rejected"
                        : item.status === "Borrado"
                        ? "rejected"
                        : "not-approved"
                    }
                  >
                    <OneColumn>
                      <Title>{item.idLocal}</Title>
                      <Title>
                        {" | Nombre: "} {item.nombre}
                      </Title>
                    </OneColumn>
                    <OneColumn>
                      <Title>{item.direccion}</Title>
                    </OneColumn>
                    <TwoColumn>
                      <Title>
                        {"Activos: "}
                        {item.cantPublicacionesActivas}
                        {" | Cuenta: "}
                        {item.flags ? item.flags : "-"}
                      </Title>
                    </TwoColumn>
                    <TwoColumn>
                      <ButtonWhatsappMobile variant="secondary" size="small">
                        <a
                          href={`https://wa.me/${whpp?.prefijo}${whpp?.valor}`}
                        >
                          {whpp?.prefijo} {whpp?.valor}
                        </a>
                      </ButtonWhatsappMobile>
                      <ButtonCustomMobile
                        variant="secondary"
                        size="small"
                        onClick={() => redirectToLocalDetail(item.idLocal)}
                      >
                        <MaximizeIcon />
                      </ButtonCustomMobile>
                    </TwoColumn>
                  </Container>
                </div>
              );
            })}
          </>
        ) : (
          <div className="table-container">
            <table className="table table-bordered">
              <thead className="table-active">
                <tr>
                  <th>
                    <button
                      type="button"
                      onClick={() => requestSort("idLocal")}
                      className={getClassNamesFor("idLocal")}
                    >
                      Id
                    </button>
                  </th>
                  <th>
                    <button
                      type="button"
                      onClick={() => requestSort("nombreLocal")}
                      className={getClassNamesFor("nombreLocal")}
                    >
                      Nombre
                    </button>
                  </th>
                  <th>
                    <button
                      type="button"
                      onClick={() => requestSort("direccion")}
                      className={getClassNamesFor("direccion")}
                    >
                      Dirección
                    </button>
                  </th>
                  <th>
                    <button
                      type="button"
                      onClick={() => requestSort("cantPublicacionesActivas")}
                      className={getClassNamesFor("cantPublicacionesActivas")}
                    >
                      Activos
                    </button>
                  </th>
                  <th>
                    <button type="button">Whatsapp</button>
                  </th>
                  <th>
                    <button
                      type="button"
                      onClick={() => requestSort("flags")}
                      className={getClassNamesFor("flags")}
                    >
                      Cuenta
                    </button>
                  </th>
                  {!isMobile && (
                    <th style={{ width: "15vmin" }}>Administrar</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {items?.map((item: LocalAdminDTO, index) => {
                  const whpp: any = item.medioDeContactoList?.find(
                    (x: any) => x.tipo === 1
                  );
                  return (
                    <tr
                      key={index}
                      className={
                        item.status === "Aprobado"
                          ? "approved"
                          : item.status === "Rechazado" ||
                            item.status === "Borrado"
                          ? "rejected"
                          : "not-approved"
                      }
                    >
                      <th onClick={() => handleClickInLine(item.idLocal)}>
                        {item.idLocal}
                      </th>
                      <th onClick={() => handleClickInLine(item.idLocal)}>
                        {item.nombre}
                      </th>
                      <th onClick={() => handleClickInLine(item.idLocal)}>
                        {item.direccion}
                      </th>
                      <th onClick={() => handleClickInLine(item.idLocal)}>
                        {item.cantPublicacionesActivas}
                      </th>
                      <th className="columWithButton">
                        {whpp && (
                          <ButtonWhatsapp variant="secondary" size="small">
                            <a
                              href={`https://wa.me/${whpp?.prefijo}${whpp?.valor}`}
                            >
                              {whpp?.prefijo} {whpp?.valor}
                            </a>
                          </ButtonWhatsapp>
                        )}
                      </th>
                      <th onClick={() => handleClickInLine(item.idLocal)}>
                        {item.flags}
                      </th>
                      {!isMobile && (
                        <th className="columWithButton">
                          <ButtonCustom
                            variant="secondary"
                            size="xsmall"
                            onClick={() => redirectToLocalDetail(item.idLocal)}
                          >
                            <MaximizeIcon />
                          </ButtonCustom>
                        </th>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div
        style={{
          position: items.length < 6 || loading ? "fixed" : "relative",
          bottom: 0,
          width: "100%",
        }}
      >
        <Footer />
      </div>
    </>
  );
};

export default AbmLocalesPage;